module.exports = __webpack_public_path__ + "static/media/payment-circle-icon-blue.d6b1cfba.svg";